import axios from 'axios';

export const moduleTaskApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/module-task`,
    headers: {
        'Content-Type': 'application/json'
    }
})